var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { s as size, _ as __spreadValues } from "./chunk-JJ6VZ5V7-350b4003.mjs";
import * as React from "react";
import { s as styled, c as color } from "./lib-42970741.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var SvgComponent = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M31.683 10.667H.34c.131-.925.305-1.86.526-2.792 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.22.916.39 1.84.516 2.758Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M.34 10.667h31.343c.254 1.844.336 3.663.314 5.35a34.717 34.717 0 0 1-.337 5.316H.325a34.914 34.914 0 0 1-.322-5.35c-.022-1.66.074-3.469.337-5.316Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M.325 21.333H31.66a30.81 30.81 0 0 1-.527 2.791s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.232-.93-.41-1.865-.54-2.79Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      d: "M1.333 9.333h1.333V10H1.333zm2.667 0h1.333V10H4zm2.667 0H8V10H6.667zm2.667 0h1.333V10H9.334zm2.666 0h1.333V10H12zm2.666 0h1.333V10h-1.333zm2.668 0h1.333V10h-1.333zm2.666 0h1.333V10H20zm2.666 0h1.333V10h-1.333zm2.668 0h1.333V10h-1.333zm2.666 0h1.333V10H28zM2.667 22H4v.667H2.667zm2.666 0h1.333v.667H5.333zM8 22h1.333v.667H8zm2.666 0h1.333v.667h-1.333zm2.668 0h1.333v.667h-1.333zM16 22h1.333v.667H16zm2.666 0h1.333v.667h-1.333zm2.668 0h1.333v.667h-1.333zM24 22h1.333v.667H24zm2.666 0h1.333v.667h-1.333zm2.668 0h1.333v.667h-1.333z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M14.133 13.05c-2.503 1.509-2.506 3.998-1.293 5.957-2.525-1.547-1.729-5.693 1.293-5.958Zm3.734 0c2.503 1.509 2.507 3.998 1.293 5.957 2.526-1.547 1.73-5.693-1.293-5.958ZM14.694 12c.644 1.068 1.325.205 1.325.205s.681.863 1.325-.205c.367.708-.702 1.354-1.325.704-.623.65-1.693.004-1.325-.704Zm-.986 7.451a3.64 3.64 0 0 0 1.567-.222s-2.116-1.032-2.074-3.135c.123-2.127 1.374-2.774 1.374-2.774s-2.226 2.936 1.044 5.39l-.144-3.036v-2.23c.185-.04.525-.395.525-.395s.34.355.526.396v2.23l-.145 3.034c3.27-2.453 1.045-5.389 1.045-5.389s1.25.647 1.374 2.774c.04 2.102-2.075 3.135-2.075 3.135.192.087.714.236 1.649.236-1.14.36-2.006.1-2.006.1L16 20l-.367-.435s-.844.243-1.925-.114Z",
      clipRule: "evenodd"
    }
  )
), "SvgComponent"), SvgFlagIrn = styled(SvgComponent)`
  ${size}
  ${color}
`, FlagIrn_default = SvgFlagIrn;
export {
  FlagIrn_default as default
};
